import { render, staticRenderFns } from "./DialogWaitingOcrInvoice.vue?vue&type=template&id=00de1e7a&"
import script from "./DialogWaitingOcrInvoice.vue?vue&type=script&lang=js&"
export * from "./DialogWaitingOcrInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports